import BaseRegulation from '../base_regulation';
import TempAccountMessageRegulationHelper from '../../helpers/temp_account_message_helper';
import GenericRealityCheckComponent from '../../../../../src/components/regulation_components/helpers/reality_check/generic_reality_check_component';
import _ from '../../../../utils/underscore';
import { SYSTEM_EVENTS } from '../../../../events/events';
import Event from '../../../../utils/event';
import { DkStructuredLogging } from './logging/dk_structured_logging';
import LastLoginComponentController
  from '../../../../components/regulation_components/base/last_login/last_login_component_controller';
import LastLoginCompositeController
  from '../../../../components/regulation_components/base/last_login/last_login_composite_controller';
import SessionTimerController from '../../../../components/session_timer/session_timer_controller';
import DKResponsibleGamingIconsController
  from '../../../../components/regulation_components/denmark/responsible_gaming_icons/dk_responsible_gaming_icons_controller';

export default class DkRegulation extends BaseRegulation {
  static CLASS = 'DkRegulation';

  _structuredLogger = null;
  _selfTestLink = "";
  _selfExclusionLink = "";


  init(params) {
    super.init(params);

    this._structuredLogger = DkStructuredLogging.create({
      serviceFactory: this.serviceFactory,
    });
    this._selfTestLink = params.selfTestLink;
    this._selfExclusionLink = params.selfExclusionLink;
  }

    sessionTimerVisible() {
        return true;
    }
  realityCheckEnabled() {
    return true;
  }

  sessionTimerEnabled() {
    return true;
  }

  showResponsibleIcons() {
    return true;
  }

  showAgeResponsibleGameInDetailedHistory() {
    return true;
  }

  showAgeResponsibleIconInGame() {
    return true;
  }

  getLastLoginComponent(params) {
      let lastLoginComponent = LastLoginComponentController.create(params);
      let sessionTimerComponent = SessionTimerController.create();
      return LastLoginCompositeController.create({lastLoginComponent: lastLoginComponent, sessionTimerComponent: sessionTimerComponent});
  }


    getResponsibleGamingIconsComponent(params){
        return DKResponsibleGamingIconsController.create(params);
    }

  showTempAccountMessage(closeFunc) {
    TempAccountMessageRegulationHelper.create({
      serviceFactory: this.serviceFactory,
    }).showTempAccountMessage({
      closeFunc: closeFunc,
      messageKey: 'dk_temp_account_message',
      titleKey: 'temp_account_title',
      btnNameKey: 'temp_account_upload_btn',
    });
  }

  _handleRealityCheckMessage(sessionTimer) {
    let realityCheckPopup = {
      title: this.serviceFactory.languageService().translation('reality_check_title'),
      closeButton: false,
      buttons: [
        {
          name: this.serviceFactory.languageService().translation('reality_check_continue_btn'),
          isClosable: true,
          callback: () => {
            this.serviceFactory.gameService().continuePlayCurrentGame();
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
              category: 'reality_check_message',
              action: 'continue_in_lobby',
            });
          },
        },
      ],
    };

    if (this.serviceFactory.gameService().isGameRunning()) {
      if (!this._realityCheckShouldBeDisplayedInGame()) {
        return;
      }

      realityCheckPopup.buttons.unshift({
        name: this.serviceFactory.languageService().translation('close_game'),
        cssClass: 'cgp-themes-3rd-cta',
        isClosable: true,
        callback: () => {
          Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'reality_check_message',
            action: 'close_game',
          });
          this.serviceFactory.gameService().closeRunningGame();
        },
      });
    }

    this.serviceFactory
      .userService()
      .getRealityCheckData()
      .then(data => {
        realityCheckPopup.text = this._getRealityCheckMessageText(data);
        this._openRealityCheckMessage(realityCheckPopup);
        this._structuredLogger.realityCheckMessageSuccess(data, this.getCurrentSessionTime());
      })
      .catch(err => {
        realityCheckPopup.text = this._getRealityCheckMessageText();
        this._openRealityCheckMessage(realityCheckPopup);
        this._structuredLogger.realityCheckMessageError(err, this.getCurrentSessionTime().toString());
      });
  }

  _realityCheckShouldBeDisplayedInGame() {
    return this.serviceFactory
      .gameService()
      .getCurrentRunningGameCompany()
      .shouldShowRealityCheckMessageWhileGameIsOpen();
  }

  _openRealityCheckMessage(messageConfig) {
    this.serviceFactory.gameService().stopCurrentGameAutoplay();
    this.serviceFactory.messageManagerService().openMessage(messageConfig);
  }

  _getRealityCheckMessageText(realityCheckData) {
    let componentConfig, component;

    if (_.isNullOrUndefined(realityCheckData)) {
      componentConfig = {
        elapsedTime: this.getCurrentSessionTime(),
        sessionBalance: 0,
      };
    } else {
      componentConfig = {
        elapsedTime: this.getCurrentSessionTime(),
        sessionBalance: -1 * realityCheckData.TotalNetLoss,
      };
    }

    component = GenericRealityCheckComponent.create(componentConfig);
    component.start();

    return component.getEl();
  }

  openSelfExclusion(view) {
    if(!this._selfExclusionLink){
      this.logger.error("Self exclusion link for dk is missing!");
      return;
    }
    this.serviceFactory.openLinkService().openLink({
      sourceLink: this._selfExclusionLink,
      view: view
    });
  }


  openSelfTest(view) {
    if(!this._selfTestLink){
      this.logger.error("Self test link for dk is missing!");
      return;
    }
    this.serviceFactory.openLinkService().openLink({
      sourceLink: this._selfTestLink,
      view: view
    });
  }
}
